export default __webpack_public_path__ + "static/speedy2-93a6dec324ea9b150957bec70da71b2b.svg";